<template>
  <div class="container" style="position: relative;">
    <div class="search_tc">
      <div class="searchInner" style="display: flex;align-items: center;">
        <div class="search_logo">
          <img src="../assets/comlogo.png" alt="">
        </div>
        <div style="display: flex;align-items: baseline;">
          <el-cascader :placeholder="cityText" ref="cascader" class="cascader" v-model="select" :options="allCity"
            :props="{ expandTrigger: 'hover', emitPath: false}" @change="cityChange"></el-cascader>
          <div class="input-out searchInputOut">
            <el-input placeholder="请输入内容" @keyup.enter.native="firstSearch" v-model="query.searchText"
              class="input-with-select">
              <el-button @click="firstSearch" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <!-- 过滤 -->
      <div class="filter">
        <div class="borderBt">
          <div class="filterTitle">区域</div>
          <div class="filterItem" style="overflow: hidden;">
            <span style="float: left;" @click="handleareaActive" :class="{activeSpan:areaActive}">不限</span>
            <span style="float: left;" @click="areaNameChange(a)" :class="{activeSpan:a==query.areaName}"
              v-for="a in areaName" :key="a">{{a}}</span>
          </div>
        </div>
        <div class="borderBt" v-if="schoolList.length" style="padding-top: 14px;">
          <div class="filterTitle">学校</div>
          <div class="filterItem" style="overflow: hidden;">
            <span style="float: left;" @click="handleSchoolActive" :class="{activeSpan:schoolActive}">不限</span>
            <span style="float: left;" @click="schoolChange(a)" :class="{activeSpan:a==query.school}"
              v-for="a in schoolList" :key="a">{{a}}</span>
          </div>
        </div>
        <div>
          <div class="filterTitle">价格</div>
          <div class="filterItem" style="position: relative;">
            <el-checkbox-group v-model="priceCheck">
              <el-checkbox @change="priceChange" v-for="(value,key,$index) in priceJson" :key="key" :label="key">
                {{value}}</el-checkbox>
            </el-checkbox-group>
            <div class="filter_money">
              <input type="text" v-model="minSellPrice">
              <span>-</span>
              <input type="text" v-model="maxSellPrice">
              <span @click="priceChooseChange">确定</span>
            </div>
          </div>
        </div>
        <div>
          <div class="filterTitle">面积</div>
          <div class="filterItem" style="position: relative;">
            <el-checkbox-group v-model="squareCheck">
              <el-checkbox @change="squareChange" v-for="(value,key,$index) in squareJson" :key="key" :label="key">
                {{value}}</el-checkbox>
            </el-checkbox-group>
            <div class="filter_money">
              <input type="text" v-model="minSquare">
              <span>-</span>
              <input type="text" v-model="maxSquare">
              <span @click="squareChooseChange">确定</span>
            </div>
          </div>
        </div>
        <div>
          <div class="filterTitle">房型</div>
          <div class="filterItem">
            <el-checkbox-group v-model="layoutCheck">
              <el-checkbox @change="layoutChange" v-for="(value,key,$index) in layoutJson" :key="key" :label="key">
                {{value}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div>
          <div class="filterTitle">朝向</div>
          <div class="filterItem">
            <el-checkbox-group v-model="faceCheck">
              <el-checkbox @change="faceChange" v-for="(value,key,$index) in faceJson" :key="key" :label="key">{{value}}
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div>
          <div class="filterTitle">装修</div>
          <div class="filterItem">
            <el-checkbox-group v-model="decorationCheck">
              <el-checkbox @change="decorationChange" v-for="(value,key,$index) in decorationJson" :key="key"
                :label="key">{{value}}</el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <!-- <div><div class="filterTitle">用途</div><div class="filterItem">
                  <el-checkbox-group  v-model="useCheck" >
                      <el-checkbox @change="useChange" v-for="(value,key,$index) in useJson" :key="key" :label="key">{{value}}</el-checkbox>
                    </el-checkbox-group>
                </div>
            </div> -->
      </div>
      <!-- 搜索结果 -->
      <div class="result_content">
        <div class="result">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="默认排序" name="all"></el-tab-pane>
            <!-- <el-tab-pane label="最新发布" name="new"></el-tab-pane> -->
            <el-tab-pane name="sale">
              <span slot="label">售价<i v-show="activeName=='sale'"
                  :class="sortSale=='sellPrice'?'el-icon-sort-up':'el-icon-sort-down'"></i></span>
            </el-tab-pane>
            <el-tab-pane name="square">
              <span slot="label">面积<i v-show="activeName=='square'"
                  :class="sortSquare=='square'?'el-icon-sort-up':'el-icon-sort-down'"></i></span>
            </el-tab-pane>
          </el-tabs>
          <div class="resultTotal">
            <span v-if="query.total>0">
              共找到 <span class="total">{{query.total}}</span> 套
            </span>
            <span v-else-if="query.total==0&&secondDatalength>0">
              正在搜索
            </span>
            <span v-else="secondDatalength==0">
              没有找到相关房源，请扩大搜索条件
            </span>
            <!-- 共找到 <span class="total">{{query.total}}</span> 套 -->
            <span v-if="secondDatalength>0"> {{city}}
              {{query.areaName}}
              {{query.school}}
              {{priceJson[priceCheck[0]]||query.minSellPrice.length>0?query.minSellPrice+'-'+query.maxSellPrice+'万':''}}
              {{squareJson[squareCheck[0]]||query.minSquare.length>0?query.minSquare+'-'+query.maxSquare+'㎡':''}}
              {{layoutJson[layoutCheck[0]]}}
              {{layoutJson[layoutCheck[0]]}}
              {{faceJson[faceCheck[0]]}}
              {{decorationJson[decorationCheck[0]]}}
              {{useJson[useCheck[0]]}}
              二手房</span>
            <span class="reset" @click="reset">
              <img src="../assets/reset.jpg" alt="">
              清空条件
            </span>
          </div>

          <div v-show="isLoading" style="width: 1150px; height: 300px; z-index: 6000;">
            <loading></loading>
          </div>

          <ul style="min-height: 100px;">
            <li class="houseItem" v-for="(item,index) in secondData" :key="item.id">

              <el-row>
                <el-col :span="6">
                  <router-link target="_blank"
                    :to="'/secondDetail?id=' + item.propertyUuid + '&title=' + (item.title || item.estateName) + ((item.countF || item.countT)?' ' + item.countF + '室' + item.countT + '厅':'')+' '+(item.direction)">
                    <div style="position: relative;">
                      <img v-if="item.isHot==1" src="../assets/hotHouse.png" class="hotHouse" alt="">
                      <img v-err-img="'./static/img/imgError.png'" class="detailImg"
                        :src="item.coverUrl || './static/img/imgError.png'" alt="">
                    </div>
                  </router-link>
                </el-col>
                <el-col :offset="1" :span="17">
                  <router-link target="_blank"
                    :to="'/secondDetail?id=' + item.propertyUuid + '&title=' + (item.title || item.estateName) + ((item.countF || item.countT)?' ' + item.countF + '室' + item.countT + '厅':'')+' '+(item.direction)"
                    class="houseTitle">
                    <p>{{item.title || item.estateName}}
                      <template v-if="!item.title&&(item.countF || item.countT)">
                        &nbsp;{{item.countF || 0}}室{{item.countT || 0}}厅
                        &nbsp;{{item.direction}}</template>
                    </p>
                  </router-link>
                  <div class="housePosition">
                    <div class="positionItem"><img src="../assets/p3.jpg" alt="">{{item.districtName}}
                      {{item.bigArea || item.areaName}}</div>
                    <div class="positionItem"><img src="../assets/p4.png" alt="">{{item.estateName}} <span
                        v-if="item.countF && item.countT">{{item.countF + '室' + item.countT + '厅'}}</span></div>
                    <div class="positionItem"><img src="../assets/p2.jpg" alt="">{{item.decoration}} | {{item.square}}平米
                      |
                      {{item.direction}}
                    </div>
                    <div class="positionItem">
                      <template v-if="item.tag">
                        <span class="iconSpan yellow" :key="t" v-for="t in item.tag.split(',')">{{t}}</span>
                      </template>
                    </div>
                    <!-- <div class="positionItem"><img src="../assets/p1.jpg" alt="">11人关注 / 2月前发布</div> -->
                    <div class="priceInfo">
                      <div class="totalPrice"><span>{{item.sellPrice}}</span>{{item.sellPriceUnit}}</div>
                      <div class="unitPrice">单价{{((item.sellPrice/item.square)*10000).toFixed(2)}}元/平米</div>
                    </div>
                    <div class="visitInfo" v-if="item.visits">
                      <strong class="visitNum">{{item.visits}}</strong>人<br>
                      浏览人数
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div v-if="index==3&&hotBanner"
                style="margin-top: 35px;border-top: 1px solid #f1f1f1; padding-top: 35px;position: relative;">
                <img src="../assets/hotBanner.jpg" alt="" style="width: 950px;">
                <div
                  style="z-index: 3000;color: #FFFFFF;position: absolute;top: 35px;right: 0px; font-size: 25px; padding: 10px;cursor: pointer;"
                  @click="hotBanner=false">
                  <i class="el-icon-close"></i>
                </div>
              </div>
            </li>
          </ul>
          <el-pagination @size-change="searchSellHouseByPage" @current-change="searchSellHouseByPage"
            :current-page.sync="query.index" :page-size="query.pageSize" layout="total, prev, pager, next,jumper"
            :total="query.total">
          </el-pagination>
        </div>
        <div style="position: absolute; top: 0;right: 0;width: 200px;height: 300px;">
          <div class="wexin_tu" :class="navBarFixed == true ? 'navBarWrap' :''">
            <p style="font-weight: 700;margin: 20px 0 10px;">关注天诚地产公众号</p>
            <img src="../assets/codeImgTwo.jpg" alt="">
            <div style=" font-size: 14px;color: #101d37;">
              <p>微信扫一扫</p>
              <p>掌握凉山房产动态</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="hotArea">
      <h3>热门商圈</h3>
      <div class="areaDiv">
        <router-link target="_blank" :to="'/second?areaName='+ a" :class="{activeArea:a==query.areaName}"
          v-for="a in areaName" :key="a">{{a}}</router-link>
      </div>
    </div>
  </div>
</template>

<script>
  import ajax from '../ajax.js'
  import loading from './loading/loading.vue'
  export default {
    // metaInfo: {
    //   title: '凉山二手房,西昌二手房,二手房买卖,二手房交易信息,二手房源', // set a title
    //   meta: [
    //     { // set meta
    //       name: 'keywords',
    //       content: '二手房,西昌二手房,凉山二手房,二手房交易,二手房源,德昌二手房,会理二手房,会东二手房'
    //     },
    //     { // set meta
    //  name: 'description',
    //  content: '天诚网二手致力于为您提供凉山二手房交易信息，出售买入，凉山人自己的二手房信息发布平台，凉山二手房买卖交易信息，包含凉山商品房价格，凉山次新房，在凉山买房卖房、就上天诚网。'
    //     }
    //   ]
    // },
    name: 'second',
    data() {
      return {
        navBarFixed: false,
        areaActive: true,
        schoolActive: true,
        hotBanner: true,
        isLoading: false,
        cityText:'',
        select: '',
        city: window.localStorage.getItem('city') || '西昌',
        secondData: [],
        allCity: [],
        activeName: 'all',
        keyword: '',
        areaName: [],
        schoolList: [],
        sortSale: 'sellPrice',
        sortSquare: 'square',
        squareCheck: [],
        layoutCheck: [],
        priceCheck: [],
        faceCheck: [],
        decorationCheck: [],
        useCheck: [],
        priceJson: {
          '0-40': '40万以下',
          '40-60': '40-60万',
          '60-80': '60-80万',
          '80-100': '80-100万',
          '100-150': '100-150万',
          '150-9999': '150万以上'
        },
        squareJson: {
          '0-40': '40㎡以下',
          '40-70': '40-70㎡',
          '70-90': '70-90㎡',
          '90-110': '90-110㎡',
          '110-130': '110-130㎡',
          '130-9999': '130㎡以上'
        },
        layoutJson: {
          '1': '一室',
          '2': '二室',
          '3': '三室',
          '4': '四室',
          '5': '四室以上'
        },
        faceJson: {
          '南北': '南北',
          '东': '朝东',
          '西': '朝西',
          '南': '朝南',
          '北': '朝北'
        },
        decorationJson: {
          '豪装': '豪装房',
          '精装': '精装房',
          '中装': '中装房',
          '简装': '简装房',
          '毛坯': '毛坯房'
        },
        useJson: {
          '居住': '居住',
          '门店': '门店'
        },
        query: {
          districtName: window.localStorage.getItem('city') || '西昌',
          areaName: '',
          school: '',
          countF: '',
          searchText: '',
          tradeType: '出售',
          decoration: '',
          direction: '',
          maxSellPrice: '',
          minSellPrice: '',
          maxSquare: '',
          minSquare: '',
          order: '',
          index: 1,
          pageSize: 30,
          total: 0
        },
        minSellPrice: '',
        maxSellPrice: '',
        maxSquare: '',
        minSquare: '',
        secondDatalength: 1
      }
    },
    components: {
      loading: loading
    },
    created() {
      this.query.searchText = this.$route.query.keyword
      this.query.areaName = this.$route.query.areaName
      this.getAllCity()
      this.getAllAreaByCity()
      this.searchSellHouseByPage()
      this.getSchoolList()
    },
    mounted() {
      window.document.querySelector('#title').innerHTML = this.query.districtName + '二手房,凉山二手房,二手房买卖,二手房交易信息,二手房源,找二手房'
      window.addEventListener('scroll', this.watchScroll)
    },
    methods: {
      // 监听滚动事件
      watchScroll() {
        var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        //  当滚动超过 时，实现吸顶效果
        if (scrollTop > 460) {
          this.navBarFixed = true
        } else {
          this.navBarFixed = false
        }
      },
      priceChooseChange() {
        if ((parseInt(this.minSellPrice) > parseInt(this.maxSellPrice)) || this.minSellPrice.length == 0 || this
          .maxSellPrice
          .length == 0) {
          this.$message.warning('请输入正确的范围')
          return
        }
        if (!/^([0]|[1-9][0-9]*)$/.test(this.maxSellPrice) || !/^([0]|[1-9][0-9]*)$/.test(this.minSellPrice)) {
          this.$message.warning('请输入正确的数字')
          return
        }
        this.query.minSellPrice = this.minSellPrice
        this.query.maxSellPrice = this.maxSellPrice
        this.priceCheck = []
        this.firstSearch()
      },
      squareChooseChange() {
        if ((parseInt(this.minSquare) > parseInt(this.maxSquare)) || this.minSquare.length == 0 || this.maxSquare
          .length ==
          0) {
          this.$message.warning('请输入正确的范围')
          return
        }
        if (!/^([0]|[1-9][0-9]*)$/.test(this.maxSquare) || !/^([0]|[1-9][0-9]*)$/.test(this.minSquare)) {
          this.$message.warning('请输入正确的数字')
          return
        }
        this.query.minSquare = this.minSquare
        this.query.maxSquare = this.maxSquare
        this.squareCheck = []
        this.firstSearch()
      },
      cityChange() { // 城市
        let nodesObj = this.$refs['cascader'].getCheckedNodes();
        this.cityText = nodesObj[0].parent.label +'/'+ nodesObj[0].label;
        this.city = nodesObj[0].label;
        this.query.districtName = this.city;
        window.localStorage.setItem('cityParent', nodesObj[0].parent.label)
        window.localStorage.setItem('city', nodesObj[0].label)
        window.localStorage.setItem('cityId', nodesObj[0].value)
        window.document.querySelector('#title').innerHTML = this.query.districtName + '二手房'
        this.getAllAreaByCity()
        this.getSchoolList()
        this.query.areaName = ''
        this.reset()
      },
      handleareaActive() {
        this.areaActive = !this.areaActive
        this.query.areaName = ''
        this.firstSearch()
      },
      handleSchoolActive() {
        this.schoolActive = !this.schoolActive
        this.query.school = ''
        this.firstSearch()
      },
      areaNameChange(a) { // 商圈
        this.query.areaName = a
        this.areaActive = false
        this.firstSearch()
      },
      schoolChange(a) { // 学校
        this.query.school = a
        this.schoolActive = false
        this.firstSearch()
      },
      priceChange(a, b) { // 价格
        this.minSellPrice = ''
        this.maxSellPrice = ''
        if (a) {
          this.priceCheck = [b.target.defaultValue]
          this.query.minSellPrice = b.target.defaultValue.split('-')[0]
          this.query.maxSellPrice = b.target.defaultValue.split('-')[1]
        } else {
          this.query.minSellPrice = ''
          this.query.maxSellPrice = ''
        }
        this.firstSearch()
      },
      squareChange(a, b) { // 面积
        this.minSquare = ''
        this.maxSquare = ''
        if (a) {
          this.squareCheck = [b.target.defaultValue]
          this.query.minSquare = b.target.defaultValue.split('-')[0]
          this.query.maxSquare = b.target.defaultValue.split('-')[1]
        } else {
          this.query.minSquare = ''
          this.query.maxSquare = ''
        }
        this.firstSearch()
      },
      layoutChange(a, b) { // 房型
        if (a) {
          this.layoutCheck = [b.target.defaultValue]
          this.query.countF = b.target.defaultValue
        } else {
          this.query.countF = ''
        }
        this.firstSearch()
      },
      faceChange(a, b) { // 朝向
        if (a) {
          this.faceCheck = [b.target.defaultValue]
          this.query.direction = b.target.defaultValue
        } else {
          this.query.direction = ''
        }
        this.firstSearch()
      },
      decorationChange(a, b) { // 装修
        if (a) {
          this.decorationCheck = [b.target.defaultValue]
          this.query.decoration = b.target.defaultValue
        } else {
          this.query.decoration = ''
        }
        this.firstSearch()
      },
      useChange(a, b) { // 用途
        if (a) {
          this.useCheck = [b.target.defaultValue]
        }
        this.firstSearch()
      },
      handleClick() { // 排序
        if (this.activeName == 'all') {
          this.query.order = ''
        }
        if (this.activeName == 'sale') {
          this.query.order = this.sortSale = this.sortSale == 'sellPrice' ? 'sellPriceDesc' : 'sellPrice'
        }
        if (this.activeName == 'square') {
          this.query.order = this.sortSquare = this.sortSquare == 'square' ? 'squareDesc' : 'square'
        }
        this.tabFirstSearch()
      },
      getAllCity() { // 获取城市
        ajax.get('city/getAllCity').then(res => {
          var bbb = JSON.parse(JSON.stringify(res.data).replace(/id/g, "value"));
          var bbb = JSON.parse(JSON.stringify(bbb).replace(/cityName/g, "label"));
          var bbb = JSON.parse(JSON.stringify(bbb).replace(/allSon/g, "children"));
          this.allCity = bbb;
          this.select = window.localStorage.getItem('cityId') || 1;
          this.cityText = window.localStorage.getItem('cityParent') +'/'+ window.localStorage.getItem('city');
        })
      },
      getAllAreaByCity() { // 获取商圈
        ajax.get('area/getAllAreaByCity', {
          params: {
            districtName: this.query.districtName
          }
        }).then(res => {
          this.areaName = res.data
        })
      },
      getSchoolList() { // 获取学校
        ajax.get('house/getSchoolListByCity', {
          params: {
            city: this.query.districtName
          }
        }).then(res => {
          this.schoolList = res.data
        })
      },
      searchSellHouseByPage() { // 搜索二手房
        if (window.scrollY > 400) {
          window.scroll(0, 0)
        }
        this.isLoading = true
        this.secondData = []
        // const loading = this.$loading({
        // 	lock: true,
        // 	text: 'Loading',
        // 	spinner: 'el-icon-loading',
        // 	background: 'rgba(0, 0, 0, 0.7)'
        // 	 });
        ajax.get('house/searchSellHouseByPage', {
          params: this.query
        }).then(res => {
          // loading.close();
          this.isLoading = false
          this.secondData = res.data.list
          this.secondDatalength = this.secondData.length
          this.query.total = res.data.total
        })
      },
      firstSearch() { // 过滤条件变化
        this.query.index = 1
        this.query.total = 0
        this.activeName = 'all'
        this.query.order = ''
        this.searchSellHouseByPage()
      },
      tabFirstSearch() { // 排序变化
        this.query.index = 1
        this.query.total = 0
        this.searchSellHouseByPage()
      },
      reset() { // 重置
        this.squareCheck = []
        this.layoutCheck = []
        this.priceCheck = []
        this.faceCheck = []
        this.decorationCheck = []
        this.useCheck = []
        this.statusCheck = []
        this.query.areaName = ''
        this.query.school = ''
        this.query.countF = ''
        this.query.searchText = ''
        this.query.decoration = ''
        this.query.direction = ''
        this.query.maxSellPrice = ''
        this.query.minSellPrice = ''
        this.query.maxSquare = ''
        this.query.minSquare = ''
        this.activeName = 'all'
        this.query.order = ''
        this.query.index = 1
        this.query.total = 0
        this.minSellPrice = ''
        this.maxSellPrice = ''
        this.minSquare = '',
          this.maxSquare = ''
        this.searchSellHouseByPage()
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  /deep/.cascader div>input {
    border: 1px #e5e7ec solid !important;
    color: #FCC00B !important;
    border-radius: unset;
    background-color: #f5f7fa !important;
    height: 40px !important;
    padding-left: 20px;
  }

  /deep/.cascader div>input::-webkit-input-placeholder {
    color: #FCC00B !important;
  }

   /deep/.cascader div>input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #FCC00B !important;
  }

   /deep/.cascader div>input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #FCC00B !important;
  }

   /deep/.cascader div>input:-ms-input-placeholder {
    /* Internet Explorer 10-11 */
    color: #FCC00B !important;
  }


  /deep/.input-with-select input {
    border-radius: unset !important;
  }

  .container {
    min-height: 900px;
    padding-bottom: 0;
  }

  .search_tc {
    background-color: #f5f5f6;
    line-height: 1;
    padding: 30px 0 26px;
    width: 100%;
  }

  .search_tc img {
    height: 40px;
    vertical-align: middle;
  }

  .searchInner {
    height: 40px;
    width: 1150px;
    margin: auto;
  }

  .search_logo {
    display: inline-block;
    vertical-align: top;
    margin-right: 30px;
  }

  .input-out {
    display: inline-block;
    width: 700px;
    padding-top: 3px;
  }

  .content {
    width: 1150px;
    margin: auto;
  }

  .filter {
    width: 1100px;
    margin: 26px auto 0;
    padding: 14px 25px;
    background-color: #fbfbfb;
    box-shadow: 0 1px 2px -1px rgba(0, 0, 0, .2);
    font-size: 12px;
    line-height: 27px;
  }

  .filterTitle {
    width: 55px;
    font-weight: 700;
    float: left;
    display: inline-block;
    vertical-align: top;
  }

  .filterItem {
    /* float: right; */
    width: 1045px;
    display: inline-block;
  }

  .filterItem span {
    color: #101d37;
    margin-right: 17px;
    cursor: pointer;
    white-space: nowrap;
  }

  .filterItem span:hover {
    color: #fcc00b;
  }

  .filterItem .activeSpan {
    color: #fcc00b;
  }

  .borderBt {
    border-bottom: 1px solid #f1f1f1
  }

  .result_content {
    position: relative;
  }

  .result {
    margin-top: 20px;
    width: 950px;
  }

  .wexin_tu {
    /* position: absolute; */
    /* 	top: 38px;
		right: 0; */
    margin-top: 38px;
    margin-left: 40px;
    width: 160px;
    height: 160px;
    border-top: 2px solid #fcc00b;

  }

  .wexin_tu img {
    /* 		position: absolute; */
    /* left: 32px; */
    width: 120px;
    height: 120px;
    width: 100px;
    height: 100px;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }

  .resultTotal {
    position: relative;
    font-size: 22px;
    line-height: 55px;
    color: #101d37;
    font-weight: 700;
  }

  .resultTotal .total {
    color: #fcc00b;
    font-family: tahoma
  }

  .resultTotal .reset {
    font-weight: 100;
    font-size: 14px;
    position: absolute;
    right: 30px;
    top: 0;
    cursor: pointer;
  }

  .resultTotal .reset img {
    width: 18px;
    height: 14px;
    margin-right: 5px;
    vertical-align: middle;
  }

  .resultTotal .reset:hover {
    color: #fcc00b;
  }

  .houseItem {
    position: relative;
    padding: 35px 0;
    border-top: 1px solid #f1f1f1;
  }

  .detailImg {
    position: relative;
    width: 232px;
    height: 174px;
    transition: all .5s;
    object-fit: cover;
  }

  .detailImg:hover {
    transform: scale(1.05);
  }

  .houseTitle {
    display: block;
    text-decoration: none;
    font-size: 22px;
    color: #101d37;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-weight: 700;
  }

  .houseTitle:hover {
    color: #fcc00b;
  }

  .housePosition {
    position: relative;
    margin-top: 22px;
  }

  .positionItem {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #101d37;
    font-size: 14px;
    margin-bottom: 18px;
  }

  .positionItem img {
    width: 16px;
    height: 16px;
    vertical-align: middle;
    margin-right: 12px
  }

  .priceInfo {
    position: absolute;
    right: 0;
    top: 30%;
  }

  .priceInfo .totalPrice {
    text-align: right;
    width: 130px;
    font-size: 14px;
    color: #db4c3f;
  }

  .priceInfo .totalPrice span {
    font-weight: 700;
    font-size: 26px;
    font-family: tahoma;
    margin-right: 5px;
  }

  .priceInfo .unitPrice {
    text-align: right;
    margin-top: 18px;
    width: 130px;
    font-size: 12px;
    color: #101d37;
    position: relative;
  }

  .iconSpan {
    display: inline-block;
    padding: 6px 7px;
    margin-right: 7px;
    line-height: 12px;
    font-size: 12px;
    vertical-align: 3px;
    border-radius: 2px;
    letter-spacing: -.27px;
    text-align: center;
    font-weight: 400;
    color: #fff;
    background: #5F94FF;
  }

  .iconSpan.yellow {
    background: #fcc00b;
    letter-spacing: 1px;
  }

  .iconSpan.grey {
    background: rgba(132, 154, 174, .1);
    color: #849aae;
  }

  .hotArea {
    margin-top: 30px;
    width: 100%;
    background-color: #f1f1f1;
    padding: 20px 0 50px;
  }

  .hotArea h3 {
    width: 1150px;
    margin: auto;
  }

  .hotArea .areaDiv {

    width: 1150px;
    margin: 10px auto 0;
    overflow: hidden;
  }

  .areaDiv a {
    color: #101d37;
    margin-right: 17px;
    cursor: pointer;
    white-space: nowrap;
    float: left;
    text-decoration: none;
  }

  .areaDiv .activeArea {
    color: #fcc00b;
  }

  .hotHouse {
    position: absolute;
    left: 0;
    top: 0;
    width: 85px;
    z-index: 2;
    image-rendering: -webkit-optimize-contrast;
    image-rendering: -moz-crisp-edges;
    image-rendering: -o-crisp-edges;
    image-rendering: crisp-edges;
    -ms-interpolation-mode: nearest-neighbor;
  }

  .visitInfo {
    font-size: 14px;
    color: #999;
    text-align: center;
    position: absolute;
    right: 120px;
    top: 50px;
    padding-right: 50px;
    border-right: 1px solid #999;
    margin-right: 50px;
  }

  .visitInfo .visitNum {
    font-size: 26px;
    color: #fcc00b;
    font-weight: 700;
  }

  .filter_money {
    position: absolute;
    height: 27px;
    top: 0;
    right: 120px;
    line-height: 27px;
  }

  .filter_money input {
    width: 50px;
    padding: 0;
    outline: none;
    text-align: center;
  }

  .filter_money span {
    margin: 0 2px;
  }

  .filter_money button {
    color: #000000;
  }

  .filter_money button span:hover {
    color: #000000;
  }

  .navBarWrap {
    position: fixed;
    top: -40px;
    z-index: 999;
  }
</style>



// WEBPACK FOOTER //
// src/components/second.vue